var identity = identity || {};
(function() {
  'use strict';
  identity.measurementChart = {
    settings: identity.pdfUtils.settings(),
    _base: null,
    _toleranceDimensions: {width:0,height:0},
    model: {
      get: function( key ) {
        return identity.pdfUtils.model.get( key, identity.measurementChart.model );
      },
      set: function( key, value ) {
        return identity.pdfUtils.model.set( key, value, identity.measurementChart.model );
      },
      reset: function() {
        Object.keys( identity.measurementChart._base ).forEach( ( key ) => {
          identity.measurementChart.model[key] = identity.measurementChart._base[key];
        } );
      },
      save: function() {
        let destinationObject = {};
        Object.keys( identity.measurementChart.model ).forEach( ( key ) => {
          if ( typeof identity.measurementChart.model[key] !== 'function' ) {
            destinationObject[key] = identity.measurementChart.model[key];
          }
        } );
        return destinationObject;
      },
      logo: '',
      name: '',
      number: '',
      toleranceImage: '',
      drawingImage: '',
      measurementDate: '',
      measurements: {},
      translations: [],
    },
    init: function() {
      identity.measurementChart._base = identity.measurementChart.model.save();
      identity.measurementChart.bindEvents();
      identity.measurementChart.getTranslations();
    },
    bindEvents: function() {
      jQuery( '.js-identity-download-measurement-chart' ).on( 'click', function( event ) {
        event.preventDefault();
        identity.pdfUtils.loader( true );
        identity.measurementChart.productData.get();

      } );
    },
    getTranslations: async () => {
      const translations = await identity.pdfUtils.translations.getValues( {
            howToMeasureHeader: 'PDF Generation - How to measure - Header',
            toleranceHeader: 'PDF Generation - Tolerance - Header',
            measurementTableHeader: 'PDF Generation - Measurement Table - Header',
            measurementFooterText: 'PDF Generation - Measurement Footer - Text',
            dateText: 'PDF Generation Date Text',
            measurementText: 'PDF Generation Measurement Chart Text',
          },
      );
      Object.keys( translations ).forEach( ( key ) => {
        identity.measurementChart.model.set( `translations.${ key }`, translations[key] );
      } );
    },
    productData: {
      get: function() {
        e4.jsonpublisher.getJsonFromUrl(
            e4.settings.ecom.product.url,
            jQuery( '.js-e-product' ).data(),
        ).done( function( jsonData ) {
          identity.measurementChart.productData.map( jsonData.product );
          identity.measurementChart.productData.extend();
          identity.pdfUtils.load( identity.measurementChart.prepareImages.init );
        } );
      },
      extend: function() {

      },
      map: function( productData ) {
        var productId = jQuery( '.js-e-product' ).data( 'productId' ),
            extendPdfData = e4.data.get( [productId, 'PdfData'].join( '_' ) );
        Object.assign( productData, extendPdfData );
        for ( var key in productData ) {
          if ( identity.measurementChart.model.hasOwnProperty( key ) === true ) {
            identity.measurementChart.model.set( key, productData[key] );
          }
        }
      },
    },
    prepareImages: {
      deferredImages: [],
      init: function() {
        if ( identity.measurementChart.model.get( 'toleranceImage' ) === null ) {
          identity.measurementChart.model.set( 'toleranceImage', identity.pdfUtils.image.fallback() );
        }
        if ( identity.measurementChart.model.get( 'drawingImage' ) === null ) {
          identity.measurementChart.model.set( 'drawingImage', identity.pdfUtils.image.fallback() );
        }
        var logo = {
              key: 'logo',
              img: identity.measurementChart.model.get( 'logo' ),
              size: {
                width: 200,
                height: 0,
              },
            },
            drawingImage = {
              key: 'drawingImage',
              img: identity.measurementChart.model.get( 'drawingImage' ),
              size: {
                width: 800,
                height: 0,
              },
            },
            toleranceImage = {
              key: 'toleranceImage',
              img: identity.measurementChart.model.get( 'toleranceImage' ),
              size: {
                width: 219,
                height: 73,
              },
            };
        identity.pdfUtils.loader( true );
        if ( logo.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.measurementChart.prepareImages.deferredImages.push( identity.measurementChart.prepareImages.load( logo, false ) );
        }

        if ( drawingImage.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.measurementChart.prepareImages.deferredImages.push( identity.measurementChart.prepareImages.load( drawingImage, false ) );
        }

        if ( toleranceImage.img.indexOf( 'data:image/png;base64' ) === -1 ) {
          identity.measurementChart.prepareImages.deferredImages.push( identity.measurementChart.prepareImages.load( toleranceImage, false ) );
        }

        jQuery.when.apply( null, identity.measurementChart.prepareImages.deferredImages ).done( function() {
          identity.measurementChart.prepareImages.deferredImages = [];
          identity.measurementChart.build();
        } );
      },
      load: function( imageObj, isSvg ) {
        var image = new Image(),
            deferred = jQuery.Deferred();
        if ( isSvg === true ) {
          var serializer = new XMLSerializer();
          jQuery.when( identity.deferImages.convertSvg( imageObj.img ) ).done( function( svg ) {
            var cleanedSvg = identity.measurementChart.prepareImages.updateSvg( svg.get( 0 ) );
            identity.measurementChart.prepareImages.insertIntoModel( imageObj, serializer.serializeToString( cleanedSvg ) );
            deferred.resolve();
          } );
        } else {
          image.onload = function() {
            var canvas = document.createElement( 'canvas' );
            canvas.width = this.naturalWidth === 0 ? imageObj.size.width : this.naturalWidth;
            canvas.height = this.naturalHeight === 0 ? imageObj.size.height : this.naturalHeight;
            canvas.getContext( '2d' ).drawImage( this, 0, 0 );
            if(imageObj.key === 'toleranceImage'){
              identity.measurementChart._toleranceDimensions.height = canvas.height;
              identity.measurementChart._toleranceDimensions.width = canvas.width;
              
              console.log(identity.measurementChart._toleranceDimensions);
            }
            imageObj.size.width = image.width;
            imageObj.size.height = image.height;
            identity.measurementChart.prepareImages.insertIntoModel( imageObj, canvas.toDataURL() );
            deferred.resolve();
          };
          image.onerror = function() {
            var fallbackImage = identity.pdfUtils.image.fallback();
            identity.measurementChart.prepareImages.insertIntoModel( imageObj, fallbackImage );
            deferred.resolve();
          };
          if ( navigator.userAgent.toLowerCase().indexOf( 'firefox' ) > -1 ) {
            image.width = imageObj.size.width;
            image.height = imageObj.size.height;
          }
          image.src = identity.pdfUtils.image.handler( imageObj.img, imageObj.size );
        }

        return deferred.promise();
      },
      insertIntoModel: function( imageObj, dataUri ) {
        if ( imageObj.index ) {
          identity.measurementChart.model.set( imageObj.key + '.' + imageObj.index + '.img', dataUri );
          identity.measurementChart.model.set( imageObj.key + '.' + imageObj.index + '.size.width', imageObj.size.width );
          identity.measurementChart.model.set( imageObj.key + '.' + imageObj.index + '.size.height', imageObj.size.height );
        } else {
          identity.measurementChart.model.set( imageObj.key, dataUri );
        }
      },
      updateSvg: function( svg ) {
        var elements = svg.querySelectorAll( 'path, polyline, polygon' );

        for ( var i = 0; i < elements.length; i++ ) {
          elements[i].setAttribute( 'style', 'fill:#6D6F70!important' );
        }
        return svg;
      },
    },
    constructor: {
      getMeasurementTable: () => {
        const measurementData = identity.measurementChart.model.get( 'measurements' );
        const data = Object.values( measurementData.Charts ).sort( ( a, b ) => a.Position - b.Position );
        const sizes = data.map( e => e.Sizes ).map( e => Object.values( e ) );
        const sortedHeaderSizes = Object.values( sizes[0] ).sort( ( a, b ) => a.ComputedValue - b.ComputedValue );

        let widths = ['auto'];
        let headers = [
          {
            text: identity.measurementChart.model.get( 'translations.measurementTableHeader' ),
            style: ['tableHeader', { alignment: 'left' }],
          }];

        sortedHeaderSizes.forEach( ( sizeObj ) => {
          widths.push( '*' );
          headers.push( {
            text: sizeObj.Name,
            style: ['tableHeader', { alignment: 'center' }],
          } );
        } );
        const bodyData = [];
        bodyData.push( headers );
        data.forEach( ( row ) => {
          const rowData = [];
          const sortedRowSizes = Object.values( row.Sizes ).sort( ( a, b ) => a.ComputedValue - b.ComputedValue );
          rowData.push( {
            text: row.Description,
            style: { alignment: 'left' },
          } );
          sortedRowSizes.forEach( ( size ) => {
            rowData.push( {
              text: size.ComputedValue,
              style: { alignment: 'center' },
            } );
          } );
          bodyData.push( rowData );
        } );

        return {
          layout: {
            fillColor: function( rowIndex ) {
              return (rowIndex % 2 === 0) ? '#f1f1f1' : null;
            },
            hLineWidth: function (i, node) {
              return 0.5;
            },
            vLineWidth: function (i, node) {
              return 0.5;
            },
            hLineColor: function (i, node) {
              return 'gray';
            },
            vLineColor: function (i, node) {
              return 'gray';
            },
          },
          table: {
            headerRows: 1,
            widths: widths,
            body: bodyData,
          },
          margin: [0, 20, 0, 0],
          style: {
            fontSize: 10,
          },
        };
      },
    },
    build: async function() {
      let titleFontSize = 22;
      const titleWidth = await identity.pdfUtils.measureText( identity.measurementChart.model.get( 'name' ), {
        fontSize: titleFontSize,
      } );
      if ( titleWidth > 340 ) {
        titleFontSize = await identity.pdfUtils.resizeText( identity.measurementChart.model.get( 'name' ), titleFontSize, 350 );
      }
      const dateText = `${ identity.measurementChart.model.get( 'translations.dateText' ) } ${ identity.measurementChart.model.get(
          'measurementDate' ) } - ${ identity.measurementChart.model.get( 'translations.measurementText' ) }`;
      
      var arrPdf = [],
          objContent = [
            {
              text: dateText, style: 'date', margin: [0, 0, 0, 30],
            },
            identity.pdfUtils.build.cornerBracket( 'top', { x: 0, y: -2 } ),
            identity.pdfUtils.build.cornerBracket( 'bottom', { x: 0, y: 25 } ),
            {
              layout: identity.pdfUtils.cleanTableLayout(),

              table: {
                widths: ['auto', '*', 50],

                body: [
                  [
                    {
                      text: `NO. ${ identity.measurementChart.model.get( 'number' ) }`,
                      style: 'productNumber',
                      margin: [8, 2, 0, 20],
                    },
                    {
                      text: identity.measurementChart.model.get( 'name' ),
                      style: {
                        fontSize: titleFontSize,
                        bold: true,
                        alignment: 'left',
                      },
                      margin: [8, (22 - titleFontSize), 0, 20],
                    },
                    identity.pdfUtils.build.image( identity.measurementChart.model.get( 'logo' ), 50, [0, -10, 0, 0] ),
                  ],
                ],
              },
            },
            identity.pdfUtils.build.line(),
            identity.measurementChart.constructor.getMeasurementTable(),
            {
              text: identity.measurementChart.model.get( 'translations.howToMeasureHeader' ),
              style: {
                fontSize: 12,
                bold: true,
                alignment: 'left',
              },
              margin: [0, 40, 0, 10],
            },
            identity.pdfUtils.build.image( identity.measurementChart.model.get( 'drawingImage' ), 400, [0, 0, 0, 0], 'center' ),
            {
              text: identity.measurementChart.model.get( 'translations.toleranceHeader' ),
              style: {
                fontSize: 12,
                bold: true,
                alignment: 'left',
              },
              margin: [0, 20, 0, 10],
            },
            identity.pdfUtils.build.image( identity.measurementChart.model.get( 'toleranceImage' ), 150, [0, 0, 0, 0] ),
          ];
      arrPdf.push( objContent );
      identity.measurementChart.create( arrPdf );
    },
    create: function( arrPdf ) {
      pdfMake.fonts = identity.pdfUtils.setFont();
      var docDefinition = {
            pageSize: 'A4',
            pageMargins: [
              30,
              20,
              30,
              70,
            ],
            content: arrPdf,
            fonts: identity.pdfUtils.setFont(),
            defaultStyle: {
              font: identity.measurementChart.settings.defaultFont,
            },
            styles: identity.pdfUtils.styles.default(),
            footer: {
              margin: [
                30,
                0,
                30,
                0,
              ],
              columns: [
                {
                  text: identity.measurementChart.model.get( 'translations.measurementFooterText' ),
                  alignment: 'center',
                  fontSize: 8,
                },
              ],
            },
          },
          pdfDocGenerator = pdfMake.createPdf( docDefinition, null, identity.pdfUtils.setFont() );
      const pdfName = `${ identity.measurementChart.model.get( 'name' ).replace( / /g, '_' ) }_${ identity.measurementChart.model.get( 'translations.measurementText' ) }.pdf`;
      pdfDocGenerator.download( pdfName );
      pdfDocGenerator.getDataUrl( function() {
        identity.pdfUtils.loader( false );
        identity.measurementChart.model.reset();
      } );
    },
  };
}());
